import { FC, HTMLAttributes, useMemo } from 'react';

// ========================= 组件 =========================
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================
import classnames from 'classnames';

// ========================= 样式 =========================
import styles from './index.module.css';

// ========================= 变量 =========================

// ========================= 类型 =========================

interface SwiperToggleButtonProps extends HTMLAttributes<HTMLDivElement> {
    // 方向
    direction: 'prev' | 'next';
    // 图标样式
    iconClassName?: string;
}

// 创建一个useGetClassName函数，用于获取styles['swiper-button-disabled']和

const SwiperToggleButton: FC<SwiperToggleButtonProps> = (props) => {

    const { direction, iconClassName, className } = props;

    // 使用classnames合并iconClassName和styles['swiper-icon']
    const iconClass = useMemo(() => classnames(styles['swiper-icon'], iconClassName), [iconClassName]);

    return (
        <div
            className={
                classnames(
                    styles['swiper-button'],
                    className
                )
            }
        >
            {
                direction === 'prev' ? <LeftOutlined className={iconClass} /> : <RightOutlined className={iconClass} />
            }
        </div>
    );
}
export default SwiperToggleButton;